import { AccessDeniedError, UnexpectedError } from '@/domain/errors'
import { MoniUserResult } from '@/domain/models'
import { GetMoniUsers } from '@/domain/usecases'
import { HttpClient, HttpStatusCode } from '@/data/protocols/http'

export class RemoteGeMoniUsersEvents implements GetMoniUsers {
  constructor (
    private readonly url: string,
    private readonly httpClient: HttpClient<string>
  ) { }

  async getUsers (params: GetMoniUsers.Params): Promise<GetMoniUsers.Result> {
    const { body, statusCode } = await this.httpClient.request({
      url: `${this.url}/api/portal/moni/lista-usuarios`,
      method: 'get',
      params
    })

    switch (statusCode) {
      case HttpStatusCode.ok: return this.mapToGeneric(body)
      case HttpStatusCode.unauthorized: throw new AccessDeniedError()

      default: throw new UnexpectedError()
    }
  }

  mapToGeneric (usersRaw: string): GetMoniUsers.Result {
    const users = usersRaw
      ? JSON.parse(usersRaw) as MoniUserResult
      : []

    return users?.map(user => ({
      nome: user.nome,
      codCliente: user.codCliente.toString(),
      dddFone: user.dddCelular,
      fone1: user.celular
    }))
  }
}
